import React, { useState } from "react";
import backArrow from "../../images/Layer 51.svg";
import Inputbox from "./Inputbox";
import "./ReviewAndConfirmation.css";

const ReviewAndConfirmation = ({
  primaryColor = "#1F3047",
  secondaryColor = "#349AC8",
  textColor = "#181818",
  placeholderColor = "#717171",
  onBack = () => {},
  onSubmit = () => {},
  errors = "",
  data,
}) => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});

  const toggleConfirmation = () => {
    setIsConfirmed(!isConfirmed);
  };

  const toggleItem = (sectionIndex, itemIndex) => {
    setExpandedItems((prev) => ({
      ...prev,
      [`${sectionIndex}-${itemIndex}`]: !prev[`${sectionIndex}-${itemIndex}`],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isConfirmed) {
      onSubmit();
    }
  };

  const sections = [
    {
      title: "Personal & Contact Information",
      items: [
        {
          name: "Personal Details",
          renderContent: (data) => <PersonalDetails data={data} />,
        },
        {
          name: "Emergency Contact Information",
          renderContent: (data) => <Emergencycontact data={data} />,
        },
        {
          name: "Personal Status",
          renderContent: (data) => (
            <PersonalStatus data={data?.personalContact} />
          ),
        },
      ],
    },
    {
      title: "Residency & Sponsor Info",
      items: [
        {
          name: "Current Living Situation",
          renderContent: (data) => (
            <LivingSituation data={data?.residencySponsor} />
          ),
        },
        {
          name: "Housing History",
          renderContent: (data) => <Housinghistory data={data} />,
        },
        {
          name: "Sponsor or Legal Guardian Info",

          renderContent: (data) => (
            <Legalguardian data={data?.residencySponsor} />
          ),
        },
        {
          name: "Legal Background Screening",
          renderContent: (data) => (
            <Legalbackground data={data?.residencySponsor} />
          ),
        },
      ],
    },
    {
      title: "Medical & Legal Information",
      items: [
        {
          name: "Health Vitals",
          renderContent: (data) => <Healthvitals data={data?.medicalLegal} />,
        },
        {
          name: "Medical History & Support",
          renderContent: (data) => <Medicalhistory data={data?.medicalLegal} />,
        },
        {
          name: "Legal & Probation Status",
          renderContent: (data) => (
            <Probationstatus data={data?.medicalLegal} />
          ),
        },
        {
          name: "Sobriety & Recovery History",
          renderContent: (data) => (
            <Recoveryhistory data={data?.medicalLegal} />
          ),
        },
      ],
    },
    {
      title: "Belongings & Devices",
      items: [
        {
          name: "Personal Items to Be Stored in the Safe",
          renderContent: (data) => (
            <Personalitems data={data?.belongingsDevices} />
          ),
        },
        {
          name: "Phones & Electronics",
          renderContent: (data) => (
            <Electronics data={data?.belongingsDevices} />
          ),
        },
        {
          name: "Additional Notes & Warnings",
          renderContent: (data) => (
            <AdditionalNotes data={data?.belongingsDevices} />
          ),
        },
      ],
    },
  ];

  return (
    <div style={containerStyle}>
      <h1 style={titleStyle(primaryColor)}>Review & Confirm Your Details</h1>

      <div style={sectionsContainerStyle}>
        {sections.map((section, sectionIndex) => (
          <SectionCard
            key={sectionIndex}
            title={section.title}
            items={section.items}
            primaryColor={primaryColor}
            expandedItems={expandedItems}
            sectionIndex={sectionIndex}
            onToggleItem={toggleItem}
            secondaryColor={secondaryColor}
            textColor={textColor}
            placeholderColor={placeholderColor}
            errors={errors}
            data={data}
          />
        ))}
      </div>

      <div style={confirmationContainerStyle}>
        <div
          style={checkboxStyle(isConfirmed, primaryColor)}
          onClick={toggleConfirmation}
          role="checkbox"
          aria-checked={isConfirmed}
        >
          {isConfirmed && <div style={checkmarkStyle} />}
        </div>
        <p style={confirmationTextStyle(textColor)}>
          I confirm that I have reviewed the above information and it is
          accurate to the best of my knowledge.
        </p>
      </div>

      <div style={buttonsContainerStyle}>
        <button
          type="button"
          onClick={onBack}
          style={backButtonStyle(secondaryColor, primaryColor)}
        >
          <div style={buttonIconStyle(secondaryColor)}>
            <img src={backArrow} alt="Back" />
          </div>
          <span style={buttonTextStyle(primaryColor)}>
            Back to Belongings & Devices
          </span>
        </button>

        <button
          type="submit"
          onClick={handleSubmit}
          disabled={!isConfirmed}
          style={submitButtonStyle(secondaryColor, !isConfirmed)}
        >
          Confirm and Continue to Final Signature
        </button>
      </div>
    </div>
  );
};

//Personal profile
const PersonalDetails = ({ data }) => {
  const {
    firstName,
    lastName,
    dob,
    phone,
    ssnLast4,
    address,
    city,
    state,
    zip,
    email,
    DLNUMBER,
    DLSTATE,
  } = data?.personalContact;

  return (
    <div className="personal-details-container">
      <div className="personal-details-container-row">
        <Inputbox label="First Name" value={firstName} />
        <Inputbox label="Last Name" value={lastName} />
      </div>
      <div className="personal-details-container-row">
        <Inputbox label="Date of Birth" value={dob} />
        <Inputbox label="Phone Number" value={phone} />
      </div>
      <div className="personal-details-container-row">
        <Inputbox label="Last 4 of SSN" value={ssnLast4} />
        <Inputbox label="Street Address" value={address} />
      </div>
      <div className="personal-details-container-row">
        <Inputbox label="email" value={email} />
        <Inputbox label="DLSTATE" value={DLSTATE} />
        <Inputbox label="DLNUMBER" value={DLNUMBER} />
      </div>
      <div className="personal-details-container-row">
        <Inputbox label="City" value={city} />
        <Inputbox label="State" value={state} />
        <Inputbox label="ZIP Code" value={zip} />
      </div>
    </div>
  );
};

//EmergencyContact
const Emergencycontact = ({ data }) => {
  const { emergencyContact } = data?.personalContact;
  const { email, name, phone, relationship } = emergencyContact;
  return (
    <div className="personal-details-container">
      <div className="personal-details-container-row">
        <Inputbox label="Full Name" value={name} />
        <Inputbox label="Relationship" value={relationship} />
      </div>
      <div className="personal-details-container-row">
        <Inputbox label="Phone Number" value={phone} />
        <Inputbox label="Email" value={email} />
      </div>
    </div>
  );
};

//PersonalStatus
const PersonalStatus = ({ data }) => {
  const { maritalStatus, hasChildren, hasVehicle, isEmployed,children,vehicleMake,vehicleModel,licensePlate,insurance } = data;
  return (
    <div className="personal-details-container">
      <div className="personal-details-container-row">
        <Inputbox label="Marital Status" value={maritalStatus} />
      </div>
      <div className="personal-details-container-row">
        <Inputbox
          label="Do you have children?"
          type="radio"
          status={hasChildren ? "Yes" : "No"}
        />
        <Inputbox
          label="Are you currently employed?"
          type="radio"
          status={isEmployed ? "Yes" : "No"}
        />
        <Inputbox
          label="Do you have a vehicle?"
          type="radio"
          status={hasVehicle ? "Yes" : "No"}
        />
      </div>
      <div className="personal-details-container-row">
        <Inputbox label="Vehicle Make" value={vehicleMake} />
        <Inputbox label="Vehicle Model" value={vehicleModel} />
      </div>
      <div className="personal-details-container-row">
        <Inputbox label="License Plate" value={licensePlate} />
        <Inputbox label="Insurance" value={insurance} />
      </div>
      <div className="personal-details-container-row">
      <table style={{ width: '100%', borderCollapse: 'collapse',border: '1px solid #ccc' }}>
  <thead>
    <tr>
      <th style={{ borderBottom: '1px solid #ccc' }}>#</th>
      <th style={{ borderBottom: '1px solid #ccc'}}>Name</th>
      <th style={{ borderBottom: '1px solid #ccc' }}>Age</th>
    </tr>
  </thead>
  <tbody>
    {children.map((child, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{child.name}</td>
        <td>{child.age}</td>
      </tr>
    ))}
  </tbody>
</table>
      </div>
    </div>
  );
};

//PersonalStatus
const LivingSituation = ({ data }) => {
  const { inFacility, facilityName, dischargeDate, entryDate } = data;
  return (
    <div className="personal-details-container">
      <div className="personal-details-container-row">
        <Inputbox
          label="Are you currently residing in a rehab or medical facility?"
          type="radio"
          status={inFacility ? "Yes" : "No"}
        />
        <Inputbox
          label="If yes, please provide the name of the facility"
          value={facilityName}
        />
      </div>
      <div className="personal-details-container-row">
        <Inputbox label="Date of entry" value={entryDate} />
        <Inputbox
          label="Expected discharge date (if known)"
          value={dischargeDate}
        />
      </div>
    </div>
  );
};

// HousingHistory
const Housinghistory = ({ data }) => {
  const { residencySponsor, medicalLegal } = data;
  const { residences } = residencySponsor;
  const { mentalHealthCondition } = medicalLegal;
  return (
    <div className="personal-details-container">
      {residences?.map((item, index) => (
        <>
          <div className="personal-details-container-row">
            <Inputbox label="Residence Location" value={item?.location} />
            <Inputbox label="Date of Stay" value={item?.dateRange} />
          </div>
          <div className="personal-details-container-row">
            <Inputbox label="Length of Stay" value={item?.length} />
            <Inputbox
              label="Responsible Party"
              value={item?.responsibleParty}
            />
          </div>
        </>
      ))}
      <div className="personal-details-container-row">
        <Inputbox
          label="Do you have a diagnosed mental health condition?"
          type="radio"
          status={mentalHealthCondition ? "Yes" : "No"}
        />
      </div>
    </div>
  );
};

//Legalguardian
const Legalguardian = ({ data }) => {
  const { sponsorName, sponsorPhone, hasPermission, sponsorRelationship } =
    data;
  return (
    <div className="personal-details-container">
      <div className="personal-details-container-row">
        <Inputbox label="Sponsor / Legal Guardian Name" value={sponsorName} />
        <Inputbox label="Phone Number" value={sponsorPhone} />
      </div>
      <div className="personal-details-container-row">
        <Inputbox label="Relationship" value={sponsorRelationship} />
        <Inputbox
          label="Do they have permission to discuss your care with us?"
          type="radio"
          status={hasPermission ? "Yes" : "No"}
        />
      </div>
    </div>
  );
};

//Legalbackground
const Legalbackground = ({ data }) => {
  const { felonyConviction, sexOffense, onProbation } = data;
  return (
    <div className="personal-details-container">
      <div className="personal-details-container-row">
        <Inputbox
          label="Have you been convicted of a felony?"
          type="radio"
          status={felonyConviction ? "Yes" : "No"}
        />
        <Inputbox
          label="Have you been convicted of a sex offense?"
          type="radio"
          status={sexOffense ? "Yes" : "No"}
        />
        <Inputbox
          label="Are you currently on probation or parole?"
          type="radio"
          status={onProbation ? "Yes" : "No"}
        />
      </div>
    </div>
  );
};

//Healthvitals
const Healthvitals = ({ data }) => {
  const {
    oxygenLevel,
    bloodAlcohol,
    urinalysis,
    bloodPressure,
    temperature,
    pulse,
    requestNumber,
  } = data;
  return (
    <div className="personal-details-container">
      <div className="personal-details-container-row">
        <Inputbox label="Blood Pressure" value={bloodPressure} />
        <Inputbox label="Temperature (°F)" value={temperature} />
      </div>
      <div className="personal-details-container-row">
        <Inputbox label="Pulse (BPM)" value={pulse} />
        <Inputbox label="Oxygen Level (%)" value={oxygenLevel} />
      </div>
      <div className="personal-details-container-row">
        <Inputbox label="Blood Alcohol (BA)" value={bloodAlcohol} />
        <Inputbox label="Urinalysis (UA)" value={urinalysis} />
      </div>
      <div className="personal-details-container-row">
        <Inputbox label="Request # (REQ)" value={requestNumber} />
      </div>
    </div>
  );
};

//Medical History & Support
const Medicalhistory = ({ data }) => {
  const {
    physicalLimitations,
    physicalLimitationsDetails,
    medicationCompliance,
    medications,
    mentalHealthCondition,
    mentalHealthDetails,
  } = data;
  return (
    <div className="personal-details-container">
      <div className="personal-details-container-row">
        <Inputbox
          label="Do you have a diagnosed mental health condition?"
          type="radio"
          status={mentalHealthCondition ? "Yes" : "No"}
        />
        <Inputbox label="If yes, please specify" value={mentalHealthDetails} />
      </div>
      <div className="personal-details-container-row">
        <Inputbox
          label="Are you currently on any medications?"
          type="radio"
          status={medications ? "Yes" : "No"}
        />
        <Inputbox label="Medication compliance" value={medicationCompliance} />
      </div>
      <div className="personal-details-container-row">
        <Inputbox
          label="Do you have physical limitations or disabilities?"
          type="radio"
          status={physicalLimitations ? "Yes" : "No"}
        />
        <Inputbox
          label="If yes, please specify"
          value={physicalLimitationsDetails}
        />
      </div>
    </div>
  );
};

//Recoveryhistory
const Recoveryhistory = ({ data }) => {
  const {
    reasonForLeaving,
    recentRehabCenter,
    rehabTimes,
    attendedRehab,
    sobrietyDate,
  } = data;
  return (
    <div className="personal-details-container">
      <div className="personal-details-container-row">
        <Inputbox label="Sobriety Date" value={sobrietyDate} />
        <Inputbox
          label="Have you attended rehab before?"
          type="radio"
          status={attendedRehab ? "Yes" : "No"}
        />
        <Inputbox label="If yes, how many times?" value={rehabTimes} />
      </div>
      <div className="personal-details-container-row">
        <Inputbox label="Most recent rehab center" value={recentRehabCenter} />
        <Inputbox label="Reason for leaving" value={reasonForLeaving} />
      </div>
    </div>
  );
};

//Probationstatus
const Probationstatus = ({ data }) => {
  const { probationStatus, legalCasesDetails, disabilityBenefits, legalCases } =
    data;
  return (
    <div className="personal-details-container">
      <div className="personal-details-container-row">
        <Inputbox
          label="Are you currently on probation or house arrest?"
          type="radio"
          status={probationStatus ? "Yes" : "No"}
        />
        <Inputbox
          label="Are you currently on disability benefits?"
          type="radio"
          status={disabilityBenefits ? "Yes" : "No"}
        />
        <Inputbox
          label="Are you involved in any active legal cases?"
          type="radio"
          status={legalCases ? "Yes" : "No"}
        />
      </div>
      <div className="personal-details-container-row">
        <Inputbox label="If yes, please specify" value={legalCasesDetails} />
      </div>
    </div>
  );
};

//Personalitems
const Personalitems = ({ data }) => {
  const { hasItemsToStore, storedItems } = data;
  const {
    // driversLicense,
    insuranceCard,
    governmentID,
    socialSecurityCard,
    cash,
    creditDebitCards,
    wallet,
    bankChecks,
    jewelry,
  } = storedItems;

  const driversLicense = true;
  return (
    <div className="personal-details-container">
      <div className="personal-details-container-row">
        <Inputbox
          label="Do you have personal items to store?"
          type="radio"
          status={hasItemsToStore ? "Yes" : "No"}
        />
      </div>
      <div className="personal-details-container">
        <table className="stored-items-table">
          <tbody>
            {/* Row 1 */}
            <tr>
              {driversLicense && (
                <td className="stored-item-cell">
                  <input
                    className="checked-inputbox"
                    type="checkbox"
                    checked={driversLicense}
                  />
                  <span>Driver's License</span>
                </td>
              )}
              {insuranceCard && (
                <td className="stored-item-cell">
                  <input
                    className="checked-inputbox"
                    type="checkbox"
                    checked={insuranceCard}
                  />
                  <span>Insurance Card</span>
                </td>
              )}
              {governmentID && (
                <td className="stored-item-cell">
                  <input
                    className="checked-inputbox"
                    type="checkbox"
                    checked={governmentID}
                  />
                  <span>Government ID</span>
                </td>
              )}
            </tr>

            {/* Row 2 */}
            <tr>
              {cash && (
                <td className="stored-item-cell">
                  <input
                    className="checked-inputbox"
                    type="checkbox"
                    checked={cash}
                  />
                  <span>Cash</span>
                </td>
              )}
              {creditDebitCards && (
                <td className="stored-item-cell">
                  <input
                    className="checked-inputbox"
                    type="checkbox"
                    checked={creditDebitCards}
                  />
                  <span>Credit/Debit Cards</span>
                </td>
              )}
              {wallet && (
                <td className="stored-item-cell">
                  <input
                    className="checked-inputbox"
                    type="checkbox"
                    checked={wallet}
                  />
                  <span>Wallet</span>
                </td>
              )}
            </tr>

            {/* Row 3 */}
            <tr>
              {socialSecurityCard && (
                <td className="stored-item-cell">
                  <input
                    className="checked-inputbox"
                    type="checkbox"
                    checked={socialSecurityCard}
                  />
                  <span>Social Security Card</span>
                </td>
              )}
              {jewelry && (
                <td className="stored-item-cell">
                  <input
                    className="checked-inputbox"
                    type="checkbox"
                    checked={jewelry}
                  />
                  <span>Jewelry</span>
                </td>
              )}
              {bankChecks && (
                <td className="stored-item-cell">
                  <input
                    className="checked-inputbox"
                    type="checkbox"
                    checked={bankChecks}
                  />
                  <span>Bank Checks</span>
                </td>
              )}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

//Electronics
const Electronics = ({ data }) => {
  const { devices } = data;
  return (
    <div className="personal-details-container">
      {devices?.map((item, index) => (
        <>
          <div className="personal-details-container-row">
            <Inputbox label="Device Type" value={item?.type} />
            <Inputbox
              label="Serial Number (Optional)"
              value={item?.serialNumber}
            />
          </div>
          <div className="personal-details-container-row">
            <Inputbox
              label="Is the charger included?"
              type="radio"
              status={item?.hasCharger ? "Yes" : "No"}
            />
            <Inputbox label="Condition of Device" value={item?.condition} />
          </div>
        </>
      ))}
    </div>
  );
};

//AdditionalNotes
const AdditionalNotes = ({ data }) => {
  const { restrictedItemsList, hasRestrictedItems, specialInstructions } = data;

  return (
    <div className="personal-details-container">
      <div className="personal-details-container-row">
        <Inputbox
          label="Are you carrying any sharp objects or restricted items?"
          type="radio"
          status={hasRestrictedItems ? "Yes" : "No"}
        />
        <Inputbox
          label="If yes, please list them"
          value={restrictedItemsList}
        />
      </div>
      <div className="personal-details-container-row">
        <Inputbox
          label="Notes or special instructions"
          value={specialInstructions}
        />
      </div>
    </div>
  );
};

// Updated Section Card Component
const SectionCard = ({
  title,
  items,
  primaryColor,
  expandedItems,
  sectionIndex,
  onToggleItem,
  secondaryColor,
  textColor,
  placeholderColor,
  errors,
  data,
}) => (
  <div style={sectionCardStyle}>
    <h2 style={sectionTitleStyle(primaryColor)}>{title}</h2>
    <div style={itemsContainerStyle}>
      {items.map((item, itemIndex) => (
        <ItemAccordion
          key={itemIndex}
          title={item.name}
          primaryColor={primaryColor}
          isExpanded={expandedItems[`${sectionIndex}-${itemIndex}`]}
          onToggle={() => onToggleItem(sectionIndex, itemIndex)}
          secondaryColor={secondaryColor}
          textColor={textColor}
          placeholderColor={placeholderColor}
          errors={errors}
          renderContent={() => item.renderContent(data)}
        />
      ))}
    </div>
  </div>
);

// New Item Accordion Component with Form Fields
const ItemAccordion = ({
  title,
  fields,
  primaryColor,
  isExpanded,
  onToggle,
  secondaryColor,
  textColor,
  placeholderColor,
  errors,
  renderContent,
}) => {
  // const [fieldValues, setFieldValues] = useState(
  //     fields.reduce((acc, field) => {
  //         acc[field.label] = field.value;
  //         return acc;
  //     }, {})
  // );

  // const handleFieldChange = (label, value) => {
  //     setFieldValues((prev) => ({
  //         ...prev,
  //         [label]: value,
  //     }));
  // };

  return (
    <div style={itemAccordionStyle}>
      <div
        style={itemHeaderStyle(isExpanded, primaryColor)}
        onClick={onToggle}
        role="button"
        aria-expanded={isExpanded}
      >
        <div style={itemTitleStyle(primaryColor)}>{title}</div>
        <div style={dropdownIconContainerStyle}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            style={{
              transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s ease",
            }}
          >
            <path d="M7 10L12 15L17 10" stroke={primaryColor} strokeWidth="2" />
          </svg>
        </div>
      </div>
      {isExpanded && <div style={fieldsContainerStyle}>{renderContent()}</div>}
    </div>
  );
};

const formRowStyle = {
  display: "flex",
  gap: "24px",
  width: "100%",
};

// Styles
const containerStyle = {
  width: "100%",
  maxWidth: "846px",
  margin: "0 auto",
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  gap: "32px",
};

const titleStyle = (color) => ({
  color: color,
  fontSize: "32px",
  fontFamily: "Mauren, sans-serif",
  fontWeight: "100",
  textAlign: "center",
  margin: "0 0 16px 0",
});

const sectionsContainerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "24px",
};

const sectionCardStyle = {
  background: "rgba(255, 255, 255, 0.8)",
  borderRadius: "16px",
  padding: "24px",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};

const sectionTitleStyle = (color) => ({
  color: color,
  fontSize: "24px",
  fontFamily: "Mauren, sans-serif",
  fontWeight: "100",
  margin: "0 0 8px 0",
});

const itemsContainerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "12px",
};

const itemAccordionStyle = {
  background: "white",
  borderRadius: "12px",
  overflow: "hidden",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
};

const itemHeaderStyle = (isExpanded, color) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "16px",
  cursor: "pointer",
  backgroundColor: isExpanded ? `${color}10` : "white",
  transition: "background-color 0.2s ease",
  ":hover": {
    backgroundColor: `${color}15`,
  },
});

const itemTitleStyle = (color) => ({
  color: color,
  fontSize: "18px",
  fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
  fontWeight: "600",
  margin: 0,
});

const dropdownIconContainerStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const fieldsContainerStyle = {
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  borderTop: `1px solid rgba(0,0,0,0.1)`,
};

const fieldContainerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  border: "1px solid red",
};

const fieldLabelStyle = (color) => ({
  color: color,
  fontSize: "14px",
  fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
  fontWeight: "500",
});

const inputStyle = (color) => ({
  width: "100%",
  padding: "12px",
  borderRadius: "8px",
  border: `1px solid ${color}`,
  fontSize: "14px",
  fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
  transition: "all 0.2s ease",
  ":focus": {
    outline: "none",
    borderColor: color,
    boxShadow: `0 0 0 2px ${color}20`,
  },
});

const checkboxInputStyle = (color) => ({
  width: "18px",
  height: "18px",
  accentColor: color,
});

const confirmationContainerStyle = {
  width: "100%",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "16px",
};

const checkboxStyle = (checked, color) => ({
  width: "24px",
  height: "24px",
  padding: "2px",
  borderRadius: "4px",
  outline: `1px ${color} solid`,
  backgroundColor: checked ? color : "transparent",
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const checkmarkStyle = {
  width: "15px",
  height: "10px",
  borderBottom: "2px solid white",
  borderLeft: "2px solid white",
  transform: "rotate(-45deg)",
  marginBottom: "2px",
};

const confirmationTextStyle = (color) => ({
  color: color,
  fontSize: "16px",
  fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
  fontWeight: "400",
  lineHeight: "24px",
  flex: "1",
});

const buttonsContainerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "24px",
  width: "100%",
};

const backButtonStyle = (secondaryColor, primaryColor) => ({
  padding: "12px 16px",
  borderRadius: "16px",
  outline: `1px solid ${secondaryColor}`,
  border: "none",
  background: "transparent",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  cursor: "pointer",
  transition: "all 0.2s ease",
  ":hover": {
    opacity: 0.8,
  },
});

const buttonIconStyle = (color) => ({
  width: "24px",
  height: "24px",
  padding: "6px",
  background: color,
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const arrowIconStyle = {
  width: "12px",
  height: "12px",
  background: "white",
  clipPath: "polygon(100% 50%, 0 0, 0 100%)",
};

const buttonTextStyle = (color) => ({
  color: color,
  fontSize: "16px",
  fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
  fontWeight: "400",
});

const submitButtonStyle = (color, disabled) => ({
  padding: "12px 16px",
  background: disabled ? "#cccccc" : color,
  borderRadius: "16px",
  border: "none",
  color: "white",
  fontSize: "16px",
  fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
  fontWeight: "400",
  cursor: disabled ? "not-allowed" : "pointer",
  transition: "all 0.2s ease",
  ":hover": {
    opacity: disabled ? 1 : 0.9,
  },
});

export default ReviewAndConfirmation;
